export default __webpack_public_path__ + "static/media/home-finance-industries-img-04.7b284456.jpg";